@use "src/sedestral/sass/mixins/texts";
@use "src/sedestral/sass/icons/icons";

.componentWebsiteBlackWordsStats {

  .union {
    margin-bottom: 14px;
  }

  .explore {
    font-size: 16px;
    margin-bottom: 30px;
    max-width: 740px;
    position: relative;

    @include texts.font("semi-bold");

    span {
      color: var(--web-blue);
    }
  }

  .charts {
    display: flex;
    flex-direction: column;
    gap: 20px;

    .entry {
      .title {
        font-size: 15px;
        color: var(--white);

        @include texts.font("semi-bold");
      }

      .chart {
        display: flex;
        align-items: center;
        gap: 15px;

        &.blue {
          .progression {
            background: var(--web-blue);
          }
        }

        &.green {
          .progression {
            background: var(--web-green);
          }
        }

        &.white {
          .progression {
            background: rgba(255, 255, 255, 0.60);
          }

          .value {
            color: var(--white-transparent);
          }
        }

        .bar {
          height: 6px;
          background: rgba(255, 255, 255, 0.25);
          width: 100%;
          overflow: hidden;
          border-radius: 6px;

          .progression {
            height: 100%;
            width: 50%;
          }
        }

        .value {
          font-size: 23px;
          color: var(--white);
          width: 70px;
          text-align: right;

          @include texts.font("bold");
        }
      }
    }
  }

  @media (max-width: 750px) {
    .charts {
      .value {
        flex: 0 0 50px;
        font-size: 18px !important;
      }
    }
  }
}